import {
  deleteObject,
  getDownloadURL,
  listAll,
  ListResult,
  ref,
  Storage,
  uploadBytesResumable
} from '@angular/fire/storage';
import { inject, Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { DocumentData } from '@angular/fire/firestore';
import { DbService } from './db.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private _db = inject(DbService);
  private _storage = inject(Storage);

  constructor() {}

  getFileList(directoryPath: string): Promise<ListResult> {
    return listAll(ref(this._storage, directoryPath));
  }

  getFile(filePath): Promise<string> {
    return getDownloadURL(ref(this._storage, filePath));
  }

  uploadFile(
    input: File | File[],
    dirPath: string = 'misc',
    validFiletypes: string[] = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'],
    progressSubject?: BehaviorSubject<number>,
    skipDownloadUrl?: boolean
  ): Promise<any[]> {
    let inputFiles: File[] = [];
    if (typeof input === 'string') {
      inputFiles = [input];
    } else {
      inputFiles = input as [];
    }
    const promises: Promise<any>[] = [];
    [...inputFiles].forEach((element) => {
      if (validFiletypes.indexOf(element.type) > -1) {
        promises.push(
          new Promise((resolve, reject) => {
            const kill$ = new Subject();
            const uploadFile: any = {};
            const path = `${dirPath}/${new Date().getTime()}_${element.name}`;
            uploadFile.path = path;
            const reff = ref(this._storage, path);
            const task = uploadBytesResumable(reff, element, { contentType: element.type });
            task.on('state_changed', (snapshot) => {
              if (progressSubject) {
                progressSubject.next(snapshot.bytesTransferred / snapshot.totalBytes);
              }
            });
            task.then(async (snapshot) => {
              uploadFile.metadata = JSON.parse(JSON.stringify(snapshot.metadata));
              if (!skipDownloadUrl) {
                uploadFile.downloadURL = await getDownloadURL(reff);
              }
              resolve(uploadFile);
            });
            task.catch((error) => {
              reject(error);
            });
          })
        );
      }
    });
    return Promise.all(promises);
  }

  deleteFile(uploadFile: any): Promise<any> {
    return deleteObject(ref(this._storage, uploadFile.path));
  }

  getDownloadURLFromFileRefPath(refPath: string): Promise<string> {
    return getDownloadURL(ref(this._storage, refPath));
  }

  getDownloadURLForThumb(parentPath: string, size: 64 | 128 | 256): Promise<string> {
    const path = parentPath.split('/');
    const filename = `thumb@${size}_${path.pop()}`;
    path.push(filename);
    const thumbPath = path.reduce((previous, current) => {
      return `${previous}/${current}`;
    });
    return this.getDownloadURLFromFileRefPath(thumbPath);
  }

  async getInstagramPosts() {
    return this._db.readDoc<DocumentData>('instagram-posts', 'LATEST').then((p) => {
      return p.data;
    });
  }
}
